import gql from "graphql-tag";

export default gql`
  fragment FinancialSegmentsFields on FinancialSegments {
    periodEndingDate
    reportSource {
      ... on SecSubmission {
        accessionNumber
        primaryDocumentHref
      }

      ... on CvmSubmission {
        primaryDocumentHref
      }
    }
    currency
    segments {
      name
      isPrimary
      ratioAdjustedIndicators {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
      financialIndicators {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
    }
    adjustedTotals {
      name
      value
      history {
        periodEndingDate
        value
      }
    }
    unadjustedTotals {
      name
      value
      history {
        periodEndingDate
        value
      }
    }
    revenueHistory {
      periodEndingDate
      value
    }
  }
`;
